import authServer from "../../server/auth";
import roleServer from "../../server/role";
import avatarServer from "../../server/avatar";
import genericSettingCrud from "../../server/genericSettingCrud";
import practiceSuiteServer from "../../server/practiceSuite";
import collaborateMDServer from "../../server/collaborateMD";
import abilityServer from "../../server/ability";
import doseSpotServer from "../../server/doseSpot";
import moment from "moment";
import { setToken } from "../../helpers/session";
import systemSettingServer from "../../server/systemSetting";
import locationServer from "../../server/location";
import coreServer from "../../server/core";
import eocServer from "../../server/eoc";
import patientZohoServer from "../../server/patientZoho";
import documentServer from "../../server/document";
import formSubmitterServer from "../../server/formSubmitter";
import EocIndex from "../../components/episode_of_care/EocsIndex";
import EocView from "../../components/episode_of_care/EocView";
import { formatEoc } from "../../helpers/episodeOfCare";
import coreServerFB from "../../../../Breeze.FormBuilder.Frontend/server/core";

const layoutModule = {
  namespaced: true,
  state: () => ({
    sidebarItemsStart: [
      {
        key: "dashboard",
        icon: "house",
        text: "Home"
      },
      {
        key: "patients",
        icon: "users",
        text: "Patients"
      },
      {
        key: "providers",
        icon: "doctor",
        text: "Providers"
      },
      // {
      //   key: "supervision",
      //   icon: "add-friend",
      //   text: "Supervision"
      // },
      {
        key: "documents",
        icon: "documents",
        text: "Documents"
      },
      {
        key: "calendar",
        icon: "calendar",
        text: "Schedule"
      },
      {
        key: "appointmentRequest",
        icon: "clock",
        text: "Appt Requests"
      },
      {
        key: "availability",
        icon: "shifts-teams",
        text: "Availability"
      },
      {
        key: "labs",
        icon: "labs",
        text: "Labs"
      },
      {
        key: "bedBoard",
        icon: "bed",
        text: "Occupancy"
      },
      {
        key: "groups",
        icon: "people",
        text: "Groups"
      },
      {
        key: "caseLoad",
        icon: "leader",
        text: "Case Load"
      },
      {
        key: "ur",
        icon: "clipboards",
        text: "Utilization"
      },
      {
        key: "mars",
        icon: "drugs",
        text: "MARS"
      },
      {
        key: "emar",
        icon: "drugs",
        text: "EMAR"
      },
      {
        key: "billing",
        icon: "invoice",
        text: "Billing"
      }
    ],

    assignedToMeDocArchiveIndex:
      localStorage.getItem("assignedToMeDocArchiveIndexToggle") === "true" ||
      false,
    seeSuperviseesPendingDocuments:
      localStorage.getItem("seeSuperviseesPendingDocumentsToggle") === "true" ||
      false,
    assignedToMeEocsIndex:
      localStorage.getItem("assignedToMeEocsIndexToggle") === "true" || false,
    assignedToMeGroupSessionIndex:
      localStorage.getItem("assignedToMeGroupSessionIndexToggle") === "true" ||
      false,
    assignedToMeMarsIndex:
      localStorage.getItem("assignedToMeMarsIndexToggle") === "true" || false,
    assignedToMeSchedulerIndex:
      localStorage.getItem("assignedToMeSchedulerIndexToggle") === "true" ||
      false,
    assignedToMeBillingIndex:
      localStorage.getItem("assignedToMeBillingIndexToggle") === "true" ||
      false,
    assignedToMeUtilizationIndex:
      localStorage.getItem("assignedToMeUtilizationIndexToggle") === "true" ||
      false,
    currentCalendarViewIndex: localStorage.getItem(
      "currentCalendarViewIndexTab"
    ),
    sidebarItemsEnd: [],
    selectedSideBarItem: "dashboard",
    showPatientsZohoModal: false,
    loading: false,
    currentUser: null,
    isDoseSpotActive: false,
    isPracticeSuiteActive: false,
    isCollaborateMDActive: false,
    isAbilityActive: false,
    roles: [],
    credentials: [],
    alert: false,
    sidebarChange: null,
    requestsPending: 0,
    isTopazIntalled: false,
    advancedOptions: false,
    selectedLocation: localStorage.getItem("selectedLocation"),
    selectedLocationObj: null,
    systemSetting: null,
    documentView: null,
    documentEditor: null,
    eocTabs: [
      {
        key: "list",
        text: "All Patients",
        component: EocIndex,
        props: {},
        closeable: false
      }
    ],
    zohoEocs: [],
    selectedEocTab: "list",
    lastLinkLocation: null,
    lastLink: null,
    defaultTreatmentPlantReviewDataFromToDo: null
  }),
  mutations: {
    setRoles(state, roles) {
      state.roles = roles;
    },
    setCredentials(state, credentials) {
      state.credentials = credentials;
    },
    setAssignToMeDocArchiveIndex(state) {
      localStorage.setItem(
        "assignedToMeDocArchiveIndexToggle",
        !state.assignedToMeDocArchiveIndex
      );
      state.assignedToMeDocArchiveIndex = !state.assignedToMeDocArchiveIndex;
    },
    setSeeSuperviseesPendingDocuments(state) {
      localStorage.setItem(
        "seeSuperviseesPendingDocumentsToggle",
        !state.seeSuperviseesPendingDocuments
      );
      state.seeSuperviseesPendingDocuments = !state.seeSuperviseesPendingDocuments;
    },
    setAssignToMeEocsIndex(state) {
      localStorage.setItem(
        "assignedToMeEocsIndexToggle",
        !state.assignedToMeEocsIndex
      );
      state.assignedToMeEocsIndex = !state.assignedToMeEocsIndex;
    },
    setAssignToMeGroupSessionIndex(state) {
      localStorage.setItem(
        "assignedToMeGroupSessionIndexToggle",
        !state.assignedToMeGroupSessionIndex
      );
      state.assignedToMeGroupSessionIndex = !state.assignedToMeGroupSessionIndex;
    },
    setAssignToMeMarsIndex(state) {
      localStorage.setItem(
        "assignedToMeMarsIndexToggle",
        !state.assignedToMeMarsIndex
      );
      state.assignedToMeMarsIndex = !state.assignedToMeMarsIndex;
    },
    setAssignToMeSchedulerIndex(state) {
      localStorage.setItem(
        "assignedToMeSchedulerIndexToggle",
        !state.assignedToMeSchedulerIndex
      );
      state.assignedToMeSchedulerIndex = !state.assignedToMeSchedulerIndex;
    },
    setAssignToMeBillingIndex(state) {
      localStorage.setItem(
        "assignedToMeBillingIndexToggle",
        !state.assignedToMeBillingIndex
      );
      state.assignedToMeBillingIndex = !state.assignedToMeBillingIndex;
    },
    setAssignToMeUtilizationIndex(state) {
      localStorage.setItem(
        "assignedToMeUtilizationIndexToggle",
        !state.assignedToMeUtilizationIndex
      );
      state.assignedToMeUtilizationIndex = !state.assignedToMeUtilizationIndex;
    },
    setCurrentCalendarViewIndex(state, currentCalendarView) {
      state.currentCalendarViewIndex = currentCalendarView;
      localStorage.setItem(
        "currentCalendarViewIndexTab",
        state.currentCalendarViewIndex
      );
    },
    async setSelectedSideBarItem(state, newSelectedItem) {
      state.selectedSideBarItem = newSelectedItem;
    },
    async setLoading(state, newValue) {
      state.loading = newValue;
    },
    async setAlert(state, alert) {
      state.alert = alert;
    },
    setDoseSpotActive(state, isActive) {
      state.isDoseSpotActive = isActive;
    },
    setPracticeSuiteActive(state, isActive) {
      state.isPracticeSuiteActive = isActive;
    },
    setCollaborateMDActive(state, isActive) {
      state.isCollaborateMDActive = isActive;
    },
    setAbilityActive(state, isActive) {
      state.isAbilityActive = isActive;
      if (isActive) {
        state.sidebarItemsStart.splice(5, 0, {
          key: "eligibility",
          icon: "leader",
          text: "Eligibility"
        });
      }
    },
    setSidebarChange(state) {
      state.sidebarChange = +new Date();
    },
    setRequestsPending(state, newValue) {
      state.requestsPending = newValue;
    },
    increaseRequestsPending(state) {
      state.requestsPending = state.requestsPending + 1;
    },
    decreaseRequestsPending(state) {
      if (state.requestsPending > 0)
        state.requestsPending = state.requestsPending - 1;
    },
    setTopazInstalled(state, isInstalled) {
      state.isTopazIntalled = isInstalled;
    },
    setSelectedLocation(state, selectedLocation) {
      const prevSelectedLocation =
        state.selectedLocation == "null" ? null : state.selectedLocation;
      state.selectedLocation = selectedLocation;
      localStorage.setItem("selectedLocation", selectedLocation);
      if (prevSelectedLocation != selectedLocation) {
        location.reload();
      }
      coreServer.selectedLocation(state.selectedLocation);
      coreServerFB.selectedLocation(state.selectedLocation);
    },
    setSelectedLocationObj(state, selectedLocationObj) {
      state.selectedLocationObj = selectedLocationObj;
      if (
        state.lastLinkLocation &&
        state.lastLinkLocation != state.selectedLocationObj.id
      ) {
        localStorage.setItem("selectedLocation", state.lastLinkLocation);
        window.history.pushState(
          null,
          document.title,
          location.href + state.lastLink + "?reload=1"
        );
        location.reload();
      }
    },
    setSystemSetting(state, systemSetting) {      
      state.systemSetting = systemSetting;
      state.advancedOptions =
        localStorage.getItem("advanced")?.trim() == systemSetting.id;
    },
    async setDocumentView(state, documentId) {
      if (documentId) {
        const documents = await documentServer.documentsFromIds(
          this.isArray ? documentId : [documentId]
        );
        if (documents.length > 0) {
          let document = documents[0];
          if (document.mode == "Results") {
            state.documentView = {
              documentId
            };
            state.lastLinkLocation = document.episodeOfCare.location.id;
            state.lastLink = `document/${documentId}`;
          } else {
            const url = formSubmitterServer.viewUrl(documentId);
            window.open(url, "_blank");
            state.documentView = null;
          }
        }
      } else {
        state.documentView = null;
      }
    },
    async setDocumentEditor(state, props) {
      if (props && props.eocId) {
        const eoc = await eocServer.get(props.eocId);
        if (eoc) {
          state.documentEditor = {
            ...props,
            defaultValues: state.defaultTreatmentPlantReviewDataFromToDo
          };
          state.lastLinkLocation = eoc.location.id;
          state.lastLink = `create-document`;
        }
      } else {
        state.documentEditor = null;
      }
    },
    async setEocTabs(state, tabs) {
      state.eocTabs = tabs;
    },
    async addEocTab(state, eocId) {
      const eoc = await eocServer.get(eocId);
      if (eoc) {
        state.lastLinkLocation = eoc.location.id;
        state.lastLink = `episode-of-care/${eocId}`;
        state.selectedSideBarItem = "patients";
        const tab = {
          key: "eoc-" + eoc.id,
          text: formatEoc(
            eoc.patient.firstName,
            eoc.patient.lastName,
            eoc.patient.mrn,
            eoc.eocn
          ),
          component: EocView,
          props: {
            eocId: eoc.id,
            clientId: eoc.patient.id
          },
          closeable: true
        };
        if (state.eocTabs.map(tab => tab.key).indexOf(tab.key) == -1) {
          const newTabs = [...state.eocTabs];
          newTabs.push(tab);
          state.eocTabs = newTabs;
        }
        state.selectedEocTab = tab.key;
      }
    },
    setSelectedEocTab(state, selectedEocTab) {
      state.selectedEocTab = selectedEocTab;
    },
    async setShowPatientsZohoModal(state, value) {
      state.showPatientsZohoModal = value;
    },
    async searchPatientZoho(state, query) {
      var eocs = await patientZohoServer.search(query);

      if (eocs.length == 1) {
        var eoc = eocs[0];
        if (eoc) {
          state.lastLinkLocation = eoc.location?.id;
          state.lastLink = `episode-of-care/${eoc.id}`;
          state.selectedSideBarItem = "patients";
          const tab = {
            key: "eoc-" + eoc.id,
            text: formatEoc(
              eoc.patient.firstName,
              eoc.patient.lastName,
              eoc.patient.mrn,
              eoc.eocn
            ),
            component: EocView,
            props: {
              eocId: eoc.id,
              clientId: eoc.patient.id
            },
            closeable: true
          };
          if (state.eocTabs.map(tab => tab.key).indexOf(tab.key) == -1) {
            const newTabs = [...state.eocTabs];
            newTabs.push(tab);
            state.eocTabs = newTabs;
          }
          state.selectedEocTab = tab.key;
        }
      } else if (eocs.length > 1) {
        state.zohoEocs = eocs;
        state.showPatientsZohoModal = true;
      } else {
        state.alert = {
          title: "The aren not patients",
          type: "error",
          message: "No one patient matchs with the filters"
        };
      }
    },
    setTreatmentPlanDefaultDataFromToDo(state, defaultData) {
      state.defaultTreatmentPlantReviewDataFromToDo = defaultData;
    }
  },
  actions: {
    show({ commit }) {
      commit("setLoading", true);
    },
    hide({ commit }) {
      commit("setLoading", false);
    },
    increaseRequestsPending({ commit }) {
      commit("increaseRequestsPending");
    },
    decreaseRequestsPending({ commit }) {
      commit("decreaseRequestsPending");
    },
    showAlertSuccess({ commit, dispatch }, data = { message: "Success!" }) {
      commit("setAlert", {
        type: "success",
        message: data.message
      });
      setTimeout(() => {
        dispatch("hideAlert");
      }, 5000);
    },
    showAlertError({ commit, dispatch, state }, { message }) {
      commit("setAlert", {
        type: "error",
        message
      });
      if (message == "Error!") {
        setTimeout(() => {
          if (state.alert && state.alert.message == "Error!") {
            dispatch("hideAlert");
          }
        }, 5000);
      }
    },
    hideAlert({ commit }) {
      commit("setAlert", null);
    },
    showError({ commit }, { message, multiline = false, title = "Error" }) {
      commit("setAlert", {
        title: title,
        type: "error",
        message,
        multiline
      });
    },
    async fetchCurrentUser(context) {
      const currentUser = await authServer.getCurrentUser();
      if (currentUser.avatarId) {
        try {
          currentUser.avatar = await avatarServer.downloadUrl(
            currentUser.avatarId
          );
        } catch {
          //
        }
      }
      context.state.currentUser = currentUser;
      if (
        !currentUser.accessToLocations ||
        currentUser.accessToLocations.length == 0
      ) {
        setToken("");
        location.reload();
      }
      let selectedLocation = localStorage.getItem("selectedLocation");
      selectedLocation = selectedLocation == "null" ? null : selectedLocation;
      if (
        selectedLocation &&
        !currentUser.accessToLocations.find(l => l.id == selectedLocation)
      ) {
        selectedLocation = currentUser.accessToLocations[0].id;
      } else if (
        !selectedLocation &&
        currentUser.accessToLocations.length == 1
      ) {
        selectedLocation = currentUser.accessToLocations[0].id;
      }
      const selectedLocationObj = selectedLocation
        ? await locationServer.get(selectedLocation)
        : null;
      context.commit("setSelectedLocation", selectedLocation);
      context.commit("setSelectedLocationObj", selectedLocationObj);
    },
    toggleAssignToMeDocArchiveIndex(context) {
      context.commit("setAssignToMeDocArchiveIndex");
    },
    toggleSeeSuperviseesPendingDocuments(context) {
      context.commit("setSeeSuperviseesPendingDocuments");
    },
    toggleAssignToMeEocsIndex(context) {
      context.commit("setAssignToMeEocsIndex");
    },
    toggleAssignToMeGroupSessionIndex(context) {
      context.commit("setAssignToMeGroupSessionIndex");
    },
    toggleAssignToMeMarsIndex(context) {
      context.commit("setAssignToMeMarsIndex");
    },
    toggleAssignToMeSchedulerIndex(context) {
      context.commit("setAssignToMeSchedulerIndex");
    },
    toggleAssignToMeBillingIndex(context) {
      context.commit("setAssignToMeBillingIndex");
    },
    toggleAssignToMeUtilizationIndex(context) {
      context.commit("setAssignToMeUtilizationIndex");
    },
    currentCalendarViewIndex(context, currentCalendarView) {
      context.commit("setCurrentCalendarViewIndex", currentCalendarView);
    },
    async fetchRoles(context) {
      const roles = await roleServer.query();
      context.commit("setRoles", roles);
    },
    async fetchCredentials(context) {
      const credentials = await genericSettingCrud.query("Credential");
      context.commit("setCredentials", credentials);
    },
    fetchSystemSetting(context) {
      systemSettingServer.get().then(result => {
        context.commit("setSystemSetting", result);
      });
    },
    fetchInitialData(context) {
      systemSettingServer.get().then(result => {
        context.commit("setSystemSetting", result);
      });
      doseSpotServer.isActive().then(result => {
        context.commit("setDoseSpotActive", result);
      });
      practiceSuiteServer.isActive().then(result => {
        context.commit("setPracticeSuiteActive", result);
      });
      collaborateMDServer.isActive().then(result => {
        context.commit("setCollaborateMDActive", result);
      });
      abilityServer.isActive().then(result => {
        context.commit("setAbilityActive", result);
      });
    },
    async generateDefaultValuesForTreatmentPlanReview(context, props) {
      const form = await context.rootGetters[
        "formBuilder/getFormBuilderFormById"
      ](props.formId);
      const parentDocumentContent = await documentServer.getDocumentsContent([
        props.parentDocumentId
      ]);
      const mapAutocompleteFunctionResult = context.rootGetters[
        "formSubmitter/superComputeFormSubmitterValue"
      ]({
        elementId: form.current.content.id,
        property: "mapAutocompleteFunctionValue",
        value: `{{
        var lastDocument = getLastOtherResult();
        var initialValues = lastDocument.results;
        ${form.current.content.properties.mapAutocompleteFunctionBody}
        initialValues;
        }}`,
        defaultValue: {},
        statements: true,
        form: {
          ...form,
          otherResults: [{ ...parentDocumentContent[0] }]
        }
      });
      for (var key in mapAutocompleteFunctionResult) {
        if (key.includes("Signature")) {
          delete mapAutocompleteFunctionResult[key];
        }
      }
      context.commit(
        "setTreatmentPlanDefaultDataFromToDo",
        mapAutocompleteFunctionResult
      );
    }
  },
  getters: {
    hasCurrentLocationAccessToSideBatItem: state => sideBarItemKey => {
      if (state.selectedLocation) {
        return true;
      }
      const sideBarItemKeyToAllLocations = [
        "dashboard",
        "patients",
        "documents",
        "calendar",
        "groups",
        "billing"
      ];
      return sideBarItemKeyToAllLocations.includes(sideBarItemKey);
    },

    isTechStaff: state =>
      state.currentUser &&
      state.currentUser.role &&
      state.currentUser.role.name == "Tech Staff",
    hasCurrentUserPermission: state => permission =>
      state.currentUser &&
      state.currentUser.role &&
      (state.currentUser.role.name == "Tech Staff" ||
        (state.currentUser.role.systemPermissions &&
          state.currentUser.role.systemPermissions[permission] &&
          state.currentUser.role.systemPermissions[permission].hasAccess)),
    hasCurrentUserDocumentPermission: state => (formId, permission) => {
      if (
        state.currentUser &&
        state.currentUser.role &&
        state.currentUser.role.name == "Tech Staff"
      ) {
        return true;
      }
      if (
        state.currentUser &&
        state.currentUser.role &&
        state.currentUser.role.documentsPermissions
      ) {
        if (!state.currentUser.role.documentsPermissions[formId]) return true;
        return state.currentUser.role.documentsPermissions[formId][permission];
      }
      return false;
    },
    hasCurrentUserPermissionAccess: state => (permission, access) => {
      return (
        state.currentUser &&
        state.currentUser.role &&
        (state.currentUser.role.name == "Tech Staff" ||
          (state.currentUser.role.systemPermissions &&
            state.currentUser.role.systemPermissions[permission] &&
            state.currentUser.role.systemPermissions[permission].hasAccess &&
            state.currentUser.role.systemPermissions[permission].access &&
            state.currentUser.role.systemPermissions[permission].access[
              access
            ]))
      );
    },
    canEditChargedEvents: (state, getters) => {
      const canEdit = getters.hasCurrentUserPermissionAccess(
        "others",
        "editChargedEvents"
      );
      return canEdit;
    },
    hasCurrentUserReportPermission: state => reportUrl =>
      state.currentUser &&
      state.currentUser.role &&
      (state.currentUser.role.name == "Tech Staff" ||
        (state.currentUser.role.reportPermissions &&
          state.currentUser.role.reportPermissions[reportUrl] &&
          state.currentUser.role.reportPermissions[reportUrl].hasAccess)),
    getRequestsPending: state => state.requestsPending,
    datesNonWorking: (state, getters, rootState) => (ymd, date) => {
      const weekday = date.getDay();
      const currentLocation = rootState.client.locations.find(
        l => l.id == state.selectedLocation
      );
      const disabledWeekDays = [];
      if (currentLocation) {
        if (!currentLocation.operatesOnMonday) {
          disabledWeekDays.push(1);
        }
        if (!currentLocation.operatesOnTuesday) {
          disabledWeekDays.push(2);
        }
        if (!currentLocation.operatesOnWednesday) {
          disabledWeekDays.push(3);
        }
        if (!currentLocation.operatesOnThursday) {
          disabledWeekDays.push(4);
        }
        if (!currentLocation.operatesOnFriday) {
          disabledWeekDays.push(5);
        }
        if (!currentLocation.operatesOnSaturday) {
          disabledWeekDays.push(6);
        }
        if (!currentLocation.operatesOnSunday) {
          disabledWeekDays.push(0);
        }
      }
      return disabledWeekDays.includes(weekday);
    },
    getCurrentAdjustedDateTime: (state, getters, rootState) => () => {
      const currentMomentUtc = moment(
        moment
          .utc()
          .format()
          .slice(0, -1)
      );
      const curentLocation = rootState.client.locations.find(
        l => l.id == state.selectedLocation
      );
      const currentMomentAdjusted = currentMomentUtc.add(
        curentLocation?.timeZoneHoursShift,
        "hours"
      );
      return currentMomentAdjusted.toDate();
    },
    getDateTimeBySelectedLocationOrEocLocation: (state, getters, rootState) => (
      eocLocationId = null
    ) => {
      const currentMomentUtc = moment(
        moment
          .utc()
          .format()
          .slice(0, -1)
      );
      const curentLocation = rootState.client.locations.find(
        l => l.id == (state.selectedLocation || eocLocationId)
      );
      const currentMomentAdjusted = currentMomentUtc.add(
        curentLocation?.timeZoneHoursShift,
        "hours"
      );
      return currentMomentAdjusted.toDate();
    }
  }
};

export default layoutModule;
